import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/coverage/index';

const fetchCoverage = createAction('fetchCoverage');
/* istanbul ignore next */
function fetchCoverageSuccess(state, action) {
  state.successFetching = true;
  state.errorFetching = false;
  state.coverage = {
    value: String(action.payload.code) !== '7' || false,
    code: String(action.payload.code),
  };
  /* istanbul ignore next */
  state.schedule = action.payload.availabilityOutList;
  state.typeAddress = action.payload.typeAddress;
}
/* istanbul ignore next */
function fetchCoverageError(state, action) {
  state.successFetching = false;
  state.errorFetching = true;
  state.coverage = { value: false, code: action.payload.code };
  state.typeAddress = action.payload.typeAddress;
  state.schedule = null;
}
/* istanbul ignore next */
function cleanCoverageStatus(state){
    state.successFetching = false;
    state.errorFetching = false;
    state.coverage =  null;
    state.schedule = null;
    state.typeAddress = null;
}
/* istanbul ignore next */
function validateStatusCoverage(state, action) {
  const { statusNumber } = action.payload;
  state.status = statusNumber;
}

const coverageReducer = createSlice({
  name: 'coverage',
  initialState,
  reducers: {
    fetchCoverageSuccess,
    fetchCoverageError,
    cleanCoverageStatus,
    validateStatusCoverage
  },
});

export const coverageActions = {
  ...coverageReducer.actions,
  fetchCoverage,
};

export default coverageReducer.reducer;
